import React, {useEffect, useState} from "react";
import {dateOptions} from "utils/constants";
import {Collapse, Row, Col, Button} from "react-bootstrap";
import ToggleBtn from "../common/modals/ToggleBtn";
import ActionButtons from "components/common/tablePages/ActionButtons";
import axios from "axiosConfig";

const SingleDcaRow = ({
                        dcaData,
                        showModal,
                        showRemoveModal,
                        setSelected,
                        setData,
                      }) => {
  const [collapsed, setCollapsed] = useState(false);
  // Value of the toggle button

  const {
    id,
    country,

    ticker,
    percent_down,
    order_max_quantity,
    total_max_quantity,
    last_close_price,
    max_amount,
    created_at,
    on_off,
    selectBroker,
    logo,
  } = dcaData;

  // Toggle dropdown

  const toggleCollapse = () => {
    setCollapsed(!collapsed);
  };
  // Handle toggling

  const setIsChecked = async e => {
    const value = e.target.checked;
    try {
      const {data} = await axios.patch(`api/dcasetting/${id}/`, {
        ...dcaData,
        on_off: value,
      });
      setData(prev => {
        const newData = [...prev];
        const index = newData.indexOf(dcaData);

        newData.splice(index, 1, data);

        return newData;
      });
    } catch (error) {
      throw new Error("Error requesting on_off update: ", error);
    }
  };
  // A Single column component, use to avoid retyping

  const SingleCol = ({colName, colValue}) => {
    return (
      // Set gray if toggle button is disabled
      <Col
        className={`d-flex h-auto justify-content-between align-items-lg-center mb-3 mb-lg-0 ${
          on_off ? "text-white" : "text-gray"
        }`}
        lg={2}
      >
        <p className="d-lg-none">{colName}</p>
        <p>{colValue}</p>
      </Col>
    );
  };
  const textCols = [
    <SingleCol colName={"Last Close"} colValue={last_close_price} key={1}/>,
    <SingleCol colName={"Percent Down"} colValue={percent_down} key={2}/>,
    <SingleCol colName={"Qty./Order"} colValue={order_max_quantity} key={3}/>,
    <SingleCol colName={"Max.Amount"} colValue={max_amount} key={4}/>,

    <SingleCol
      colName={"Date Added"}
      colValue={new Date(created_at).toLocaleDateString("en-GB", dateOptions)}
      key={5}
    />,
    <SingleCol colName={"broker"} colValue={selectBroker} key={6}/>,
  ];

  const buttonCols = [
    <Col
      className={`d-flex justify-content-between mb-3 mb-lg-0 me-xl-1 ${
        on_off ? "text-white" : "text-gray"
      }`}
      key={7}
    >
      <p className="d-lg-none">Off/On</p>
      <ToggleBtn isChecked={on_off} setIsChecked={setIsChecked}/>
    </Col>,
    <Col
      className={`d-flex justify-content-end justify-content-lg-center justify-content-xl-end ms-xl-2`}
      key={8}
    >
      <ActionButtons
        data={dcaData}
        setSelected={setSelected}
        showModal={showModal}
        showRemoveModal={showRemoveModal}
        marginClass={"me-xl-1"}
      />
    </Col>,
  ];

  return (
    <Row>
      <Col
        className={`d-lg-flex align-items-center justify-content-between lighter-section py-lg-4 px-4 ps-xl-2 pe-xl-5 mb-3`}
      >
        <Col lg={1} xl={2} className="d-flex p-0 me-lg-3">
          <div className="d-flex ">
            <div className="d-lg-none d-xl-block me-2">{logo}</div>
            <p className="d-lg-none me-1 account-name">Ticker: </p>
            <p className={`m-0 d-flex account-name ${on_off ? "" : "grayed"}`}>
              {ticker}
            </p>
          </div>
          <Button
            variant="link"
            onClick={toggleCollapse}
            aria-expanded={collapsed}
            className="text-white ms-auto d-lg-none"
          >
            <i className={"bi bi-chevron-" + (collapsed ? "up" : "down")}></i>
          </Button>
        </Col>
        <Col
          sm={9}
          className="d-none d-lg-flex justify-content-between align-content-center"
        >
          {textCols}
        </Col>
        <Col
          sm={2}
          xl={"auto"}
          className="d-none d-lg-flex justify-content-between align-content-center me-xl-2"
        >
          {buttonCols}
        </Col>

        <Col className="d-lg-none">
          <Collapse in={collapsed} className="mt-3 mt-lg-auto ">
            <Col>
              {textCols}
              {buttonCols}
            </Col>
          </Collapse>
        </Col>
      </Col>
    </Row>
  );
};

export default SingleDcaRow;
